import React from 'react';
import InpageBase from './InpageBase';

import TInpage from './types/TInpage';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Info = (props: TInpage) => <InpageBase {...props} signal={FeedbackSignals.Info} />;

export default Info;
